import { invokeFastApi } from '../apis/fastapi';
import { logError } from '../utils';
import { useToaster } from './toast';

export interface UpdateSlackbotChannelParams {
  team_id: string;
  channel_id: string;
  is_autorespond?: boolean;
  respond_only_if_answer_found?: boolean;
  bot_id?: string;
}

interface UpdateSlackbotChannelBody {
  is_autorespond?: boolean;
  respond_only_if_answer_found?: boolean;
  bot_id?: string;
}

interface SlackbotChannelsResponse {
  updateSlackbotChannel: (params: UpdateSlackbotChannelParams) => Promise<void>;
}

export const useSlackbotChannels = (): SlackbotChannelsResponse => {
  const toaster = useToaster();

  const updateSlackbotChannel = async ({
    team_id,
    channel_id,
    is_autorespond,
    respond_only_if_answer_found,
    bot_id,
  }: UpdateSlackbotChannelParams) => {
    const bodyData: UpdateSlackbotChannelBody = {};

    if (is_autorespond !== undefined) {
      bodyData.is_autorespond = is_autorespond;
    }

    if (respond_only_if_answer_found !== undefined) {
      bodyData.respond_only_if_answer_found = respond_only_if_answer_found;
    }

    if (bot_id !== undefined) {
      bodyData.bot_id = bot_id;
    }

    try {
      await invokeFastApi({
        // eslint-disable-next-line @cspell/spellchecker
        path: `/bots/slack/channels/${team_id}/${channel_id}`,
        method: 'PATCH',
        body: bodyData,
      });

      toaster.success('Slack channel updated successfully');
    } catch (fetchError) {
      logError(fetchError);
      toaster.failure('Failed to update slack channel');
    }
  };

  return {
    updateSlackbotChannel,
  };
};
